<template>
    <div class="py-4 px-4 bg-gray-200 shadow-md rounded dark:bg-gray-800 w-full h-full">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Card"
}
</script>

<style scoped>

</style>
